module.exports = __webpack_public_path__ + "img/medical-record.88ef21f8.svg";